// Durata della transizione di espansione dei gruppi in FieldsGenerator (enter()):
// finche' non e' finita l'altezza del gruppo cresce ancora e l'offset del campo e'
// quello vecchio, quindi lo scroll atterrerebbe nel punto sbagliato.
const GROUP_EXPAND_MS = 300

export default {

	methods: {
		/**
		 * Input:  nessuno (legge ErrorBag e fieldsset del form)
		 * Fa:     porta a schermo il primo campo in errore, espandendo il suo gruppo
		 * Output: Promise|undefined
		 */
		handleValidationErrorAdvanced () {
			const generator = this.$refs.fieldsgenerator
			if (!generator || !generator.$validator) return

			const target = this.firstInvalidElement(generator.$validator)
			if (!target) return

			const field = this.fieldDefinitionOf(generator, target)
			const eraCollassato = !!field
				&& !!field.group_id
				&& !!generator.groupsExpanded
				&& !generator.groupsExpanded[field.group_id]

			if (field && generator.expandGroupForField) {
				generator.expandGroupForField(field.key)
			}

			if (eraCollassato) {
				return new Promise((resolve) => {
					setTimeout(() => resolve(this.scrollToElement(target)), GROUP_EXPAND_MS)
				})
			}

			return this.$nextTick(() => this.scrollToElement(target))
		},

		/**
		 * Input:  object validator (il $validator del FieldsGenerator)
		 * Fa:     trova l'elemento del campo in errore che viene per primo nel DOM
		 * Output: HTMLElement|null
		 *
		 * L'ErrorBag e' indicizzato per LABEL (data-vv-name) e le label non sono
		 * univoche: in un form con molti custom field piu' campi si chiamano allo
		 * stesso modo, e cercare la label nel fieldsset restituisce un campo omonimo
		 * gia' compilato. L'elemento lo si prende quindi da vee-validate, che sa
		 * quale campo ha fallito; l'ordine e' quello del documento, non quello del bag.
		 */
		firstInvalidElement (validator) {
			const elementi = validator.errors.items
				.map((errore) => this.elementOfError(validator, errore))
				.filter((el) => el && el.compareDocumentPosition)

			if (!elementi.length) return null

			return elementi.reduce((primo, el) => {
				// DOCUMENT_POSITION_PRECEDING (2): el viene prima di primo
				return (primo.compareDocumentPosition(el) & 2) ? el : primo
			})
		},

		/**
		 * Input:  object validator, object errore (una voce dell'ErrorBag)
		 * Fa:     risale dall'errore all'elemento del campo che lo ha prodotto
		 * Output: HTMLElement|null
		 *
		 * Non si usa `fields.find({ id })`: gli errori aggiunti a mano con
		 * `errors.add()` non hanno `id` (_normalizeError normalizza solo scope e
		 * vmId) e `Field.matches()` senza id/name/scope ritorna true, cioe' il
		 * PRIMO campo registrato — lo scroll finirebbe su un campo a caso.
		 * `findById()` legge la mappa itemsById e senza id restituisce null; per
		 * quegli errori si ripiega sul nome, che e' la label (data-vv-name).
		 */
		elementOfError (validator, errore) {
			const perNome = errore.scope
				? { name: errore.field, scope: errore.scope }
				: { name: errore.field }
			const campo = (errore.id ? validator.fields.findById(errore.id) : null)
				|| validator.fields.find(perNome)

			return (campo && (campo.el || (campo.vm && campo.vm.$el))) || null
		},

		/**
		 * Input:  object generator (FieldsGenerator), HTMLElement el
		 * Fa:     risale dall'elemento alla sua definizione di campo, per il gruppo
		 * Output: object|undefined
		 */
		fieldDefinitionOf (generator, el) {
			const fields = this.fieldsset && this.fieldsset.fields
			const elenco = Array.isArray(fields) ? fields : Object.values(fields || {})

			return elenco.find((f) => {
				const ref = generator.$refs[f.key]
				const componente = Array.isArray(ref) ? ref[0] : ref
				const nodo = componente && (componente.$el || componente)
				return nodo && nodo.contains && nodo.contains(el)
			})
		},

		/**
		 * Input:  HTMLElement el
		 * Fa:     scrolla al contenitore del campo, sotto la app bar
		 * Output: Promise|undefined
		 */
		scrollToElement (el) {
			if (!el) return
			// L'input nudo sta dentro il .v-input: scrollare al contenitore lascia
			// visibile anche la label e l'eventuale messaggio d'errore.
			return this.$vuetify.goTo(el.closest('.v-input') || el, { offset: 60 })
		},
	},
}
